import { Button } from '@heroui/button';
import { Card, CardBody } from '@heroui/card';
import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const NotFound: React.FC = () => {
  const pageTitle = 'Page Not Found';
  const pageDescription = 'The page you are looking for does not exist.';

  return (
    <>
      <SEOHead title={pageTitle} description={pageDescription} />
      <div className='min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-md w-full'>
          <Card>
            <CardBody className='text-center py-12'>
              <h1 className='text-6xl font-bold text-gray-300 mb-2'>404</h1>
              <h2 className='text-xl font-semibold text-gray-900 mb-2'>
                Page not found
              </h2>
              <p className='text-gray-600 mb-6'>
                Sorry, we couldn't find the page you're looking for.
              </p>
              <div className='flex flex-col sm:flex-row gap-3 justify-center'>
                <Button as={Link} to='/' color='primary'>
                  Back to home
                </Button>
                <Button as={Link} to='/browse' variant='bordered'>
                  Browse products
                </Button>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default NotFound;
